import React, { useEffect, useState } from 'react';
import { useAuthStore } from '@/store/auth.store';
import { refresh } from '@/features/auth';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const storedToken = localStorage.getItem('agrovet_refresh_token');
    if (!storedToken) {
      setReady(true);
      return;
    }
    refresh(storedToken)
      .then((result) => {
        useAuthStore
          .getState()
          .setTokens(result.accessToken, result.refreshToken, new Date(result.accessTokenExpiresAt));
      })
      .catch(() => {
        useAuthStore.getState().clearAuth();
      })
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-blue-600" />
      </div>
    );
  }

  return <>{children}</>;
}
